import { isAfter, isSameDay } from 'date-fns';

export const disableRightArrow = ({ selectedDate, endDateLimit }) => {
  if (!selectedDate) {
    return true;
  }
  if (endDateLimit && isSameDay(selectedDate, endDateLimit)) {
    return true;
  }
  if (isAfter(selectedDate, endDateLimit)) {
    return true;
  }
  return false;
};
export const disableLeftArrow = ({ selectedDate, startDateLimit }) => {
  return selectedDate <= startDateLimit;
};
